import React, {PropsWithChildren, useEffect} from "react";

export default function Overlay({
                                    isOpen = false,
                                    children,
                                    zIndex = 100,
                                }: {
    isOpen?: boolean
    zIndex?: number
} & PropsWithChildren) {
    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "";
        }

        return () => {
            document.body.style.overflow = "";
        };
    }, [isOpen]);
    return isOpen ? <div
        className="matchid-overlay"
        style={{
            zIndex
        }}
    >
        {children}
    </div> : <></>
}